import { Monitor, MoonStar, Sun } from 'lucide-react';
import { Radio, RadioGroup } from 'react-aria-components';
import { setTheme, useTheme, type ThemePreference } from '../lib/theme';

const options = [
  { value: 'system', label: 'Sistema', Icon: Monitor },
  { value: 'light', label: 'Claro', Icon: Sun },
  { value: 'dark', label: 'Oscuro', Icon: MoonStar },
] as const;

export function ThemeControl() {
  const theme = useTheme();
  return (
    <div className="user-menu-appearance">
      <div>
        <p>Apariencia</p>
        <small>{options.find((option) => option.value === theme)?.label}</small>
      </div>
      <RadioGroup
        className="theme-control"
        aria-label="Apariencia"
        orientation="horizontal"
        value={theme}
        onChange={(value) => setTheme(value as ThemePreference)}
      >
        {options.map(({ value, label, Icon }) => (
          <Radio key={value} value={value} className="theme-option" aria-label={label}>
            <span className="theme-option-icon" title={label}>
              <Icon size={18} strokeWidth={1.6} aria-hidden="true" />
            </span>
          </Radio>
        ))}
      </RadioGroup>
    </div>
  );
}
